// talliv prototype — site behaviors (header, nav, reveal, PDP, tabs, newsletter)

(function () {
  // header shadow on scroll
  const hdr = document.querySelector('.hdr');
  if (hdr) {
    const onScroll = () => hdr.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // mobile nav
  const mnav = document.querySelector('.mnav');
  const mOverlay = document.querySelector('.mnav-overlay');
  const navOpen = document.querySelector('[data-nav-open]');
  const navClose = document.querySelector('[data-nav-close]');
  const setNavOpen = open => {
    if (!mnav || !mOverlay) return;
    if (!open && navOpen) navOpen.focus();
    mnav.classList.toggle('open', open);
    mOverlay.classList.toggle('open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    mnav.setAttribute('aria-hidden', String(!open));
    mnav.inert = !open;
    if (navOpen) navOpen.setAttribute('aria-expanded', String(open));
    if (open && navClose) navClose.focus();
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-nav-open]')) setNavOpen(true);
    if (e.target.closest('[data-nav-close]') || e.target === mOverlay) setNavOpen(false);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mnav && mnav.classList.contains('open')) {
      setNavOpen(false);
      return;
    }
    if (e.key !== 'Tab' || !mnav || !mnav.classList.contains('open')) return;
    const focusable = Array.from(mnav.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Mobile homepage purchase shortcut. Hide it where a primary CTA or the footer
  // is already visible, so it supports the long narrative without duplicating it.
  const homeSticky = document.querySelector('[data-home-sticky]');
  const stickyBlockers = [
    document.querySelector('.ed-hero'),
    document.querySelector('.final-offer'),
    document.querySelector('.footer'),
  ].filter(Boolean);
  if (homeSticky && stickyBlockers.length && 'IntersectionObserver' in window) {
    const visibleBlockers = new Set();
    const syncSticky = () => {
      homeSticky.classList.toggle('is-visible', visibleBlockers.size === 0);
    };
    const stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visibleBlockers.add(entry.target);
        else visibleBlockers.delete(entry.target);
      });
      syncSticky();
    }, { threshold: 0.01 });
    stickyBlockers.forEach(blocker => stickyObserver.observe(blocker));
  }

  // Open a linked FAQ item when navigating directly to its anchor.
  const openTargetedDetails = () => {
    if (!window.location.hash) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  };
  window.addEventListener('hashchange', openTargetedDetails);
  openTargetedDetails();

  // reveal on scroll
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.01, rootMargin: '0px 0px -40px 0px' });
    // Motion is opt-in only after the reveal controller is ready.
    document.documentElement.classList.add('js-ready');
    document.querySelectorAll('.reveal').forEach(n => io.observe(n));
    // Safety net: content must never stay hidden if the observer misses
    // (bfcache restore, background tab, prerender). Force-show anything
    // at or above the viewport that still lacks .in after a grace period.
    const revealSafetyNet = () => {
      document.querySelectorAll('.reveal:not(.in)').forEach(n => {
        if (n.getBoundingClientRect().top < window.innerHeight + 100) n.classList.add('in');
      });
    };
    setTimeout(revealSafetyNet, 1500);
    window.addEventListener('pageshow', () => setTimeout(revealSafetyNet, 300));
  } else {
    document.querySelectorAll('.reveal').forEach(n => n.classList.add('in'));
  }

  // tabs
  document.querySelectorAll('.tabs').forEach(tabs => {
    const btns = tabs.querySelectorAll('.head button');
    const panes = tabs.querySelectorAll('[data-tabpane]');
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.classList.remove('active'));
      panes.forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      tabs.querySelector(`[data-tabpane="${b.dataset.tab}"]`).classList.add('active');
    }));
  });

  // PDP mobile gallery
  let resetGallery = () => {};
  const gallery = document.querySelector('.media-col');
  if (gallery) {
    const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
    const prev = gallery.querySelector('.gallery-prev');
    const next = gallery.querySelector('.gallery-next');
    let galleryIndex = 0;
    let touchStartX = null;

    const selectGalleryItem = index => {
      if (!items.length) return;
      galleryIndex = (index + items.length) % items.length;
      items.forEach((item, i) => item.classList.toggle('active', i === galleryIndex));
      thumbs.forEach((thumb, i) => {
        const active = i === galleryIndex;
        thumb.classList.toggle('active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      selectGalleryItem(Number(thumb.dataset.galleryIndex));
    }));
    if (prev) prev.addEventListener('click', () => selectGalleryItem(galleryIndex - 1));
    if (next) next.addEventListener('click', () => selectGalleryItem(galleryIndex + 1));

    gallery.addEventListener('touchstart', event => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', event => {
      if (touchStartX === null) return;
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) > 45) selectGalleryItem(galleryIndex + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    resetGallery = () => selectGalleryItem(0);
    selectGalleryItem(0);
  }

  // PDP pack selector → ATC button
  const packs = document.querySelectorAll('.pack[data-key]');
  const atcBtn = document.querySelector('[data-atc]');
  const stickyBtn = document.querySelector('[data-atc-sticky]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  let selectedPack = null;

  const upsellCard = document.getElementById('upsell-card');
  const twoPack = document.querySelector('.pack[data-key="two-pure"], .pack[data-key="two-nature"]');

  function selectPack(p, skipUpsell = false, keepImage = false) {
    packs.forEach(x => {
      x.classList.remove('active');
      x.setAttribute('aria-pressed', 'false');
    });
    p.classList.add('active');
    p.setAttribute('aria-pressed', 'true');
    selectedPack = { key: p.dataset.key, label: p.dataset.label };
    const selectedVariant = window.TallivNativeVariant(selectedPack.key);
    const selection = document.querySelector('[data-selected-pack]');
    if (selection) {
      selection.hidden = false;
      selection.querySelector('[data-selected-pack-label]').textContent = selectedPack.label;
      selection.querySelector('[data-selected-pack-price]').textContent = window.TallivMoney(selectedVariant?.price || 0);
      const saving = p.querySelector('.save');
      selection.querySelector('[data-selected-pack-saving]').textContent = saving ? Array.from(saving.childNodes).map(node => node.textContent.trim()).filter(Boolean).join(' · ') : '';
    }
    const bundled = /^(travel|two)-/.test(selectedPack.key);
    const packImage = selectedVariant?.product.featured_image;
    // A pack preselected by data-default keeps the preloaded hero image (LCP); only a chosen pack swaps it.
    const imageUrl = keepImage ? null : typeof packImage === 'string' ? packImage : packImage?.src;
    document.querySelectorAll('.media-col [data-gallery-item] img, .media-col [data-gallery-index="0"] img').forEach((image, index) => {
      if (index > 0 && !image.closest('[data-gallery-index="0"]')) return;
      if (!image.dataset.originalSrc) {
        image.dataset.originalSrc = image.getAttribute('src');
        image.dataset.originalAlt = image.alt;
        image.dataset.originalSrcset = image.getAttribute('srcset') || '';
      }
      image.src = bundled && imageUrl ? imageUrl : image.dataset.originalSrc;
      image.alt = bundled && imageUrl ? selectedVariant.product.title : image.dataset.originalAlt;
      if ((bundled && imageUrl) || !image.dataset.originalSrcset) image.removeAttribute('srcset');
      else image.setAttribute('srcset', image.dataset.originalSrcset);
    });
    gallery?.classList.toggle('has-selected-bundle', Boolean(bundled && imageUrl));
    resetGallery();
    const url = new URL(window.location.href);
    url.searchParams.set('pack', selectedPack.key);
    if (bundled) url.searchParams.delete('variant');
    else if (selectedVariant) url.searchParams.set('variant', selectedVariant.id);
    window.history.replaceState(window.history.state, '', url);
    const txt = `${window.TallivText('sb6f702cab799')} · ${window.TallivMoney(window.TallivNativeVariant(selectedPack.key)?.price || 0)}`;
    if (atcBtn) {
      const variant = window.TallivNativeVariant(selectedPack.key);
      atcBtn.disabled = !variant?.available;
      atcBtn.textContent = atcBtn.disabled ? window.TallivText('s6aeb9c33db88') : txt;
    }
    if (stickyBtn) { stickyBtn.disabled = !window.TallivNativeVariant(selectedPack.key)?.available; stickyBtn.textContent = stickyBtn.disabled ? window.TallivText('s6aeb9c33db88') : txt; }
    if (stickyPrice) stickyPrice.textContent = `${selectedPack.label} · ${window.TallivMoney(window.TallivNativeVariant(selectedPack.key)?.price || 0)}`;
    // Show upsell card only when single unit is selected
    if (upsellCard && !skipUpsell) {
      upsellCard.hidden = !['pure-120','nature-120'].includes(p.dataset.key);
    }
  }
  packs.forEach(p => {
    p.addEventListener('click', () => selectPack(p));
    p.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      selectPack(p);
    });
  });
  if (packs.length) {
    const params = new URLSearchParams(window.location.search);
    const requested = Array.from(packs).find(p => p.dataset.key === params.get('pack'));
    const variant = Array.from(packs).find(p => String(window.TallivNativeVariant(p.dataset.key)?.id) === params.get('variant'));
    selectPack(requested || variant || document.querySelector('.pack[data-default]') || packs[0], false, !requested && !variant);
  }

  // Upsell card: accept → select 2-pack
  const upsellAccept = document.querySelector('[data-upsell-accept]');
  if (upsellAccept && twoPack) {
    upsellAccept.addEventListener('click', () => {
      selectPack(twoPack, true);
      if (upsellCard) upsellCard.hidden = true;
    });
  }
  // Upsell card: dismiss
  const upsellDismiss = document.querySelector('[data-upsell-dismiss]');
  if (upsellDismiss && upsellCard) {
    upsellDismiss.addEventListener('click', () => { upsellCard.hidden = true; });
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', () => {
      if (selectedPack) window.Cart.add(selectedPack.key);
    });
  }
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      if (selectedPack) {
        window.Cart.add(selectedPack.key);
        return;
      }
      const packList = document.querySelector('.packs');
      if (packList) {
        packList.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => packs[0] && packs[0].focus(), 450);
      }
    });
  }

  const stickyAtc = document.querySelector('.sticky-atc');
  const regularAtc = document.querySelector('.atc-row');
  if (stickyAtc && regularAtc && 'IntersectionObserver' in window) {
    const purchaseTargets = [
      document.querySelector('.packs'),
      upsellCard,
      regularAtc,
      document.querySelector('.pdp3-final'),
      document.querySelector('.footer'),
    ].filter(Boolean);
    const visibleTargets = new Set();
    const stickyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visibleTargets.add(entry.target);
        else visibleTargets.delete(entry.target);
      });
      stickyAtc.classList.toggle('is-hidden', visibleTargets.size > 0);
    }, { threshold: 0.35 });
    purchaseTargets.forEach(target => stickyObserver.observe(target));
  }

  // proof collage quote rotator
  const pq = document.querySelector('.pq-quotes');
  if (pq && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const items = pq.querySelectorAll('.pq-item');
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('active');
        i = (i + 1) % items.length;
        items[i].classList.add('active');
      }, 4500);
    }
  }

  // Newsletter capture (prototype: no backend, so success is simulated).
  // Validation is real: an unvalidated field sends malformed addresses to the
  // email platform, where they cost deliverability instead of subscribers.
  document.querySelectorAll('.nl-form:not([data-native-newsletter])').forEach(form => {
    const input = form.querySelector('input[type="email"]');
    const ok = form.parentElement.querySelector('.nl-ok');
    if (!input) return;

    const setMessage = (text, valid) => {
      if (!ok) return;
      ok.textContent = text;
      ok.style.display = 'block';
      ok.classList.toggle('is-error', !valid);
    };

    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      if (ok) ok.style.display = 'none';
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      const value = input.value.trim();
      if (!value || !input.checkValidity()) {
        input.setAttribute('aria-invalid', 'true');
        setMessage(window.TallivText('sae73d347823d'), false);
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      setMessage(window.TallivText('s5a7e0a2e30d8'), true);
      input.value = '';
    });
  });
})();


